var exports = {
  "a": "Box__puTgfR",
};

module.exports = exports;
